import { FC } from "react"
import { Tag } from 'mk-pc'

interface Props {
    status?: number
}
/**
 * 公共状态
 */
export const CommonStatus: FC<Props> = (props) => {
    const { status } = props

    switch (status) {
        case 0:
            return <Tag>未启用</Tag>
        case 1:
            return <Tag color="green">启用</Tag>
        default:
            return <Tag>未知</Tag>
    }
}